import React, { createContext, useState, useEffect } from 'react';
import { clearProfileInfo } from './slices/profileSlice';
import { useDispatch } from 'react-redux';
import WhmcsApi from './services/WhmcsApi';
import { fetchValidateSession } from './helpers/apiUtils';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [showLoginExpired, setShowLoginExpired] = useState(false);
  const [userAuth, setUserAuth] = useState(() =>
    localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')) : null
  );

  const dispatch = useDispatch();

  const setTokens = (data) => {
    localStorage.setItem('userAuth', JSON.stringify(data));
    setUserAuth(data);
  };

  const fetchLogout = async (token) => {           
    const whmcsApi = new WhmcsApi();
    const response = await whmcsApi.request('logout', {}, 'POST', token);

    // if(response.result == 'success'){
      localStorage.removeItem('userAuth');
      setUserAuth(null);
      dispatch(clearProfileInfo());
      fetchValidateSession(userAuth?.token, setShowLoginExpired, setUserAuth);
    // }
  };

  const logout = () => {
    //borra cookies de sesión
    fetchLogout(userAuth?.token)
  };

  return (
    <AuthContext.Provider value={{ userAuth, setUserAuth: setTokens, logout, showLoginExpired, setShowLoginExpired }}>
      {children}
    </AuthContext.Provider>
  );
};
